import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, InputNumber, Button, Row, Col, Radio, message } from 'antd';
import moment from 'moment';
const DiscountForm = ({ visible, onCancel, onSubmit, initialData }) => {
  const [form] = Form.useForm();
  const [couponType, setCouponType] = useState(initialData?.couponType ? initialData?.couponType : 'public');
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const percent = values.percent;
        const maxAmount = values.maxAmount;
        const flatAmount = values.flatAmount;
        
        if ((!percent || !maxAmount) && !flatAmount) {
          message.error('Please input either Percent discount and Maximum discount amount, or Flat discount amount.');
          return;
        } else if ((percent && maxAmount) && flatAmount) {
          message.error('Please input either Percent discount and Maximum discount amount, or Flat discount amount, not both.');
          return;
        } else if ((percent && flatAmount) || (maxAmount && flatAmount)) {
          return message.error('Please input either Percent discount and Maximum discount amount, or Flat discount amount, not both.');
        }

        values.couponType = couponType;
        values.disCountType = (values?.flatAmount == undefined || values?.flatAmount == 0) ? 0 : 1 // 0 for flatAmount and 1 for percent

        onSubmit(values);
        form.resetFields();
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  return (
      <Modal
        title={initialData ? 'Edit Discount' : 'Add Discount'}
        visible={visible}
        width={1000}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            {initialData ? 'Update' : 'Submit'}
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout="horizontal"
          name="form_in_modal"
          initialValues={{
            ...initialData,
            validFrom: initialData ? moment(initialData.validFrom) : null,
            validTo: initialData ? moment(initialData.validTo) : null,
          }}
        >
          <Form.Item
            name="title"
            //   label="Title"
            rules={[{ required: true, message: 'Please input the title!' }]}
          >
            <Input placeholder="Enter discount title" />
          </Form.Item>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                className="min-w-screen"
                name="validFrom"
                rules={[{ required: true, message: 'Please select the start date!' }]}
              >
                <DatePicker style={{ width: '100%' }} placeholder="Valid From" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="validTo" rules={[{ required: true, message: 'Please select the end date!' }]}>
                <DatePicker style={{ width: '100%' }} placeholder="Valid To" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="percent"
              // rules={[{ required: true, message: 'Please input the discount percent!' }]}
              >
                <InputNumber style={{ width: '100%' }} placeholder="Percent discount" min={0} max={100} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="maxAmount"
              // rules={[{ required: true, message: 'Please input the maximum discount amount!' }]}
              >
                <InputNumber style={{ width: '100%' }} placeholder="Maximum discount amount" min={0} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="flatAmount"
          // rules={[{ required: false, message: 'Please input the flat discount amount!' }]}
          >
            <InputNumber style={{ width: '100%' }} min={0} placeholder="Flat discount amount" />
          </Form.Item>
          <Form.Item name="redemptionLimit" rules={[{ required: true, message: 'Please input the redemption limit!' }]}>
            <InputNumber style={{ width: '100%' }} min={1} placeholder="Redemption Limit" />
          </Form.Item>

          <Form.Item>
            <Radio.Group onChange={(e)=> setCouponType(e.target.value)} value={couponType}  rules={[{ required: true, message: 'Please select coupon type!' }]}>
              <Radio value="public">Public</Radio>
              <Radio value="private">Private</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
  );
};

export default DiscountForm;
